export const PREFERENCE_KEY = 'admin.experimentalBookingScreens'

export const safeStorage = (method, ...args) => {
    try { return window.localStorage[method](...args) } catch { return null }
}

export const readPreference = storage => {
    try { return storage.getItem(PREFERENCE_KEY) === 'true' } catch { return false }
}
export const writePreference = (storage, enabled) => {
    try { storage.setItem(PREFERENCE_KEY, String(enabled)) } catch { /* Session preference still works. */ }
}
export const switchAllowed = (guards, confirmDiscard) => !guards.some(guard => guard.pending)
    && (!guards.some(guard => guard.dirty) || confirmDiscard())
